import { DocumentNode } from 'graphql';
import { PartialResourcePage } from './types';
import { DocumentForm } from './document-form';
import { ResourcePageType } from 'src/graphql/generated/graphql';
import { VideoForm } from './video-form';

type ResourceFormProps = {
  type: ResourcePageType;
  resource?: PartialResourcePage;
  refetchQueries?: DocumentNode[];
  onCancel: () => void;
  onSave: () => void;
};

export const ResourceForm = ({
  type,
  resource,
  refetchQueries = [],
  onCancel,
  onSave,
}: ResourceFormProps) => {
  const resourceType = resource?.type || type;

  if (
    resourceType === ResourcePageType.Document ||
    resourceType === ResourcePageType.Download
  ) {
    return (
      <DocumentForm
        type={resourceType}
        resource={resource}
        refetchQueries={refetchQueries}
        onCancel={onCancel}
        onSave={onSave}
      />
    );
  }

  return (
    <VideoForm
      resource={resource}
      refetchQueries={refetchQueries}
      onCancel={onCancel}
      onSave={onSave}
    />
  );
};
